export default "__VITE_ASSET__RZdw0Fko__"